export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"

export const CLEAR_FORGET_PASSWORD_ERROR = "CLEAR_FORGET_PASSWORD_ERROR"

export const CLEAR_FORGET_PASSWORD_SUCCESS_MESSAGE = "CLEAR_FORGET_PASSWORD_SUCCESS_MESSAGE"
